import { createOrderCart, deleteOrdercartApi, getOrderCartApi, saveCartData, updateOrdercartApi } from "../../apis/transactional";
import { NETWORK_RESPONSE_STATUS } from "../../utils/global_variables";
import { ORDER_CART } from "../actionTypes";
import { orderEntryApiPending } from "./orders";
import { toastConfig } from "./toast";

// BT-106965_27_02_2024_SrikanthRao_ordercart

export const getOrderCartAction = () => async (dispatch, getState) => {
    try {
        let objResponse = await getOrderCartApi();
        if (objResponse?.status === NETWORK_RESPONSE_STATUS?.SUCCESS) {
            dispatch(getOrderCartSucces(objResponse?.data.data));
        } else {
            dispatch(getOrderCartFail([]));
        }
    } catch (error) {
        dispatch(getOrderCartFail([]));

    }
};

export const updateOrdercartMargin = (payload) => {
    return { type: ORDER_CART?.UPDATE_ORDER_CART_MARGIN, payload };
};

export const getOrderCartSucces = (payload) => {
    return { type: ORDER_CART?.GET_ORDER_CART_SUCCES, payload };
};
export const getOrderCartFail = (payload) => {
    return { type: ORDER_CART?.GET_ORDER_CART_FAIL, payload };
};

export const updateOrderCartAction = (payload, stringMsg) => async (dispatch, getState) => {
    try {
        //BT-106965 : Order Cart : ManasaB : 23-07-2024 : Duplicates cart creating issue - Start
        dispatch(orderEntryApiPending(true));
        let objResp = await updateOrdercartApi(payload);
        if (objResp?.status === NETWORK_RESPONSE_STATUS?.SUCCESS) {
            dispatch(getOrderCartAction()); //ManasaB : 19/03/2024 : To refresh after rename
            dispatch(updateOrderCartRowData({}));
            dispatch(toastConfig({ autoDismiss: true, show: true, message: stringMsg }));
            if (objResp?.data) {
                return Promise.resolve(objResp.data);
            }


        } else {

        }
    } catch (error) {

    }
    finally {
        dispatch(orderEntryApiPending(false));
    }
    //BT-106965 : Order Cart : ManasaB : 23-07-2024 : Duplicates cart creating issue  - End
};
export const deleteOrderCartAction = (payload, objSelectedCartRowData) => async (dispatch, getState) => {
    try {
        let objResp = await deleteOrdercartApi(payload);
        if (objResp?.status === NETWORK_RESPONSE_STATUS?.SUCCESS) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `Cart "${objSelectedCartRowData?.ordercartName}" deleted successfully` }));
            dispatch(getOrderCartAction());
        } else {

        }
    } catch (error) {

    }
};

export const updateOrderCartRowData = (payload) => {
    return { type: ORDER_CART?.UPDATE_ORDER_CART_SELECTED_ROW, payload };
};

//BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - Start
export const createOrderCartInfo = (payload) => async (dispatch, getState) => {
    // {/* Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - Start */ }
    try {
        dispatch(orderEntryApiPending(true));
        dispatch(orderCartConfirmApiStatus(true));
        let objResp = await createOrderCart(payload);
         //BT-106965 : Order Cart : ManasaB 17-07-2024 - Start
        if (objResp?.data.status === 'success' && objResp?.data.data.length > 0) {
            dispatch(saveCartSuccess(true));
          //  dispatch(getOrderCartOrderSuccess(objResp?.data));  //BT-106965 : Order Cart : ManasaB : 23-07-2024 : Side tray code changes  : ManasaB : 14-08-2024 : Need to uncomment again after merging of side tray order cart code
            return Promise.resolve(objResp?.data); //ManasaB : 14-08-2024 : Order cart  hotfix issue
        } else {
            return Promise.resolve(objResp?.data)
        }
         //BT-106965 : Order Cart : ManasaB 17-07-2024 - End
    } catch (error) {
        return Promise.reject(error);
    }
    finally {
        dispatch(orderEntryApiPending(false));
        dispatch(orderCartConfirmApiStatus(false));
    }
    // {/* Vinit Raut : 24-04-2024 : - Breeze - Implemented loader while triggering API - End */ }
};
export const saveCartSuccess = (payload) => {
    return { type: ORDER_CART?.CART_SAVED_SUCCESS, payload };
};
export const saveCartInfo = (payload) => async (dispatch, getState) => {
    try {
        //BT-106965 : Order Cart : ManasaB : 23-07-2024 : Duplicates cart creating issue  - Start
        dispatch(orderEntryApiPending(true));
        let objResp = await saveCartData(payload);
        if (objResp?.data) {
            return Promise.resolve(objResp.data);
        }

    } catch (error) {
        console.log('Error in saveCartInfo', error);
    }
    finally {
        dispatch(orderEntryApiPending(false));
        dispatch(orderCartConfirmApiStatus(false));
    }
    //BT-106965 : Order Cart : ManasaB : 23-07-2024 : Duplicates cart creating issue  - End
};
export const storeGridData = (payload) => {
    return { type: ORDER_CART?.ORDERENTRY_GRID_DATA, payload };
};
export const orderCartConfirmApiStatus = (payload) => {
    return { type: ORDER_CART?.ORDERENTRY_CART_API_PENDING, payload };
};
//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - Start
export const saveCartForGoback = (payload) => {
    return { type: ORDER_CART?.CART_SAVED_GOBACK, payload };
};
//BT-106965 : Order Cart : ManasaB : 23-07-2024 : Side tray code changes - Start
export const getOrderCartOrderSuccess = (payload) => {
    return { type: ORDER_CART?.PLACE_ORDERCART_ORDER_SUCCESS, payload };
};
export const getOrderCartScrps = (payload) => {
    return { type: ORDER_CART?.GET_ORDER_CART_SCRIPS, payload };
};
export const getOrderDataBackupVertical = (payload) => {
    return {type : ORDER_CART?.GET_ORDER_CART_BACKUP_VERTICAL,payload}
}
export const getOrderMarketPriceList = (payload) => {
    return {type : ORDER_CART?.GET_ORDER_MARKET_PRICE,payload}
}
  //BT-106965 : Order Cart : ManasaB : 23-07-2024 : Side tray code changes - End
//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - End
//BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - End